import * as types from './types';

export const changeZoomLevel = zoomLevelConfig => ({
  type: types.CHANGE_ZOOM_LEVEL,
  zoomLevelConfig,
});

export const init = () => ({
  type: types.INIT,
});

export const changeDetailHighlight = detailHighlightTime => ({
  type: types.TIMELINE_DETAIL_HIGHLIGHT,
  detailHighlightTime,
});
